import React from "react";
import OptionCard from "./OptionCard";

const TextChatView = ({ series }: { series: any }) => (
  <div className="space-y-4">
    <p className="text-gray-800 font-medium">{series.question.text}</p>
    <div className="flex gap-3 overflow-x-auto pb-2">
      {series.options.map((opt: any) => (
        <OptionCard
          key={opt.id}
          option={opt}
          isCorrect={series.answer.includes(opt.id)}
        />
      ))}
    </div>
  </div>
);

export default TextChatView;
